import Head from "next/head";

function BreadcrumbsMetaHead(props: any) {
  const { breadCrumbList = [] } = props;

  const itemListElement = [
    { title: "Home", url: "/" },
    ...breadCrumbList,
  ]
    .filter(Boolean)
    .filter((_) => _.url);

  const microdata = {
    "@context": "http://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: itemListElement.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.title,
      item: {
        "@type": "Thing",
        "@id": `https://partsavatar.ca${item.url}`,
      },
    })),
  };

  return (
    <Head>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(microdata) }}
      />
    </Head>
  );
}

export default BreadcrumbsMetaHead;
